// extracted by mini-css-extract-plugin
export default {"wrapper":"_8VUN9R8XTkExj1fvDUDL"};